import registrationService from '../registration-hosting-service.js';
import Pagination from '@/components/pagination/index.vue';
import {purchaseProjectStatus} from '@/utils/mixins/purchase-project-status';
import { changeSkin } from '@/utils/common.js';
export default {
  components: {
    Pagination
  },
  mixins: [purchaseProjectStatus],
  data() {
    return {
      total: 0,
      tableList: [],
      searchForm: {
        projectType: 2, // 1转让 2采购
        pageNum: 1,
        pageSize: 5
      }
    };
  },
  created() {
    this.getSignUpRecordList();
  },
  computed: {
  },
  methods: {
    changeSkin,
    // 获取信息披露列表
    getSignUpRecordList(page){
      this.tableList = [];
      if (page) {
        this.searchForm.pageNum = page.pageNo;
        this.searchForm.pageSize = page.pageSize;
      }
      registrationService.selectListByPage(this.searchForm).then(res => {
        if (res && res.code === '0') {
          this.tableList = res.data.list;
          this.total = res.data.total;
          console.log(this.tableList);
        }
      });
    },
    clear () {
      this.searchForm = {
        projectType: '',
        pageNum: 1,
        pageSize: 5
      };
      this.getSignUpRecordList();
    },
    handdle (row, event, column) {
      console.log(row, event, column);
      this.$router.push('/registration-hosting/hostDetail?id=' + row.id);
    }
  }
};
